import React from "react";
import { Box, Popover, Typography } from "@mui/material";
import { Link, PencilSimpleLine, UsersThree } from "@phosphor-icons/react";

interface SpaceMenuPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onEditSpace?: () => void;
  onAddUsers?: () => void;
  onCopySpaceId?: () => void;
}

const menuBoxSx = {
  padding: "10px",
  background: "white",
  boxShadow: "0 0 3px rgba(0,0,0,.3)",
  border: "1px solid rgba(208, 213, 221, 1)",
  display: "flex",
  flexDirection: "column",
  minWidth: "150px",
};

const menuItemSx = {
  width: "100%",
  display: "flex",
  gap: "5px",
  cursor: "pointer",
  padding: "10px 2px",
  border: "none",
  background: "none",
  alignItems: "center",
  "&:hover": {
    background: "rgba(231, 240, 255, 1)",
  },
};

const iconColor = "rgba(102, 112, 133, 1)";
const textColor = "rgba(71, 84, 103, 1)";

export const SpaceMenuPopover: React.FC<SpaceMenuPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  onEditSpace,
  onAddUsers,
  onCopySpaceId,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorReference="anchorEl"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: { marginTop: "8px" },
        },
      }}
    >
      <Box sx={menuBoxSx}>
        {onEditSpace && (
          <Box
            component="button"
            sx={menuItemSx}
            onClick={() => {
              onClose();
              onEditSpace();
            }}
          >
            <PencilSimpleLine size={20} color={iconColor} />
            <Typography sx={{ width: "100%", color: textColor }}>
              Edit space
            </Typography>
          </Box>
        )}
        {onAddUsers && (
          <Box
            component="button"
            sx={menuItemSx}
            onClick={() => {
              onClose();
              onAddUsers();
            }}
          >
            <UsersThree size={20} color={iconColor} />
            <Typography sx={{ width: "100%", color: textColor }}>
              Add Users
            </Typography>
          </Box>
        )}
        {onCopySpaceId && (
          <Box
            component="button"
            sx={menuItemSx}
            onClick={() => {
              onClose();
              onCopySpaceId();
            }}
          >
            <Link size={20} color={iconColor} />
            <Typography sx={{ width: "100%", color: textColor }}>
              Copy Space ID
            </Typography>
          </Box>
        )}
      </Box>
    </Popover>
  );
};
